<template>
    <SwLayout>
        <div class="dm-wizard-field" v-if="submission">
            <div
                class="form-group fv-plugins-icon-container dm-heard-from-textarea"
            >
                <label>{{ translate("Where did you hear about us?") }}</label>

                <textarea
                    class="form-control"
                    v-model="submission.heard_from"
                    @change="saveSubmission()"
                />
            </div>

            <div class="form-group fv-plugins-icon-container dm-subscribe-news">
                <label>{{ translate("If you are interested to know more about our company, you can opt in to receiving news from us.") }}</label>

                <div class="radio-inline">
                    <label class="radio">
                        <input
                            type="radio"
                            name="radios2"
                            :value="false"
                            v-model="submission.subscribe_news"
                            @change="saveSubmission()"
                        />
                        <span></span>
                        {{ translate("No") }}
                    </label>
                    <label class="radio">
                        <input
                            type="radio"
                            name="radios2"
                            :value="true"
                            v-model="submission.subscribe_news"
                            @change="openPrivacyPolicyModal()"
                        />
                        <span></span>
                        {{ translate("Yes") }}
                    </label>
                </div>
            </div>
        </div>

        <modal
            size="lg"
            class="text-left dm-modal dm-privacy-policy-modal"
            id="dm-privacy-policy-modal"
            :title="companyName + ': ' + translate('Privacy Policy')"
        >
            <div class="mb-4" v-html="news_privacy_policy"></div>

            <button
                type="button"
                class="btn btn-primary font-weight-bolder dm-btn-wizard"
                @click="hideModalAndSaveSubmissions()"
            >
                {{ translate("I agree") }}
            </button>
        </modal>
    </SwLayout>
</template>

<script>
import { validationMixin } from "@/mixins/validationMixin.js";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapState, mapWritableState, mapActions } from "pinia";

export default {
    mixins: [validationMixin],

    data () {
        return {
            companyName: companyName, // Must exist in DOM.
        };
    },

    computed: {
        ...mapState(useSubmissionWizardStore, ["news_privacy_policy"]),
        ...mapWritableState(useSubmissionWizardStore, [
            "submission",
            "bottom_navigation_rules",
        ]),

        isValid() {
            return (
                this.isHeardFromFieldPopulated && this.isSubscribeFieldPopulated
            );
        },

        isHeardFromFieldPopulated() {
            if (!this.submission) return false;
            if (!this.submission.heard_from) return false;
            if (this.submission.heard_from.length == 0) return false;
            return true;
        },

        isSubscribeFieldPopulated() {
            if (!this.submission) return false;
            if (this.submission.subscribe_news === false) return true;

            if (this.submission.subscribe_news === true)
                if (this.submission.agree_privacy_policy) return true;

            return false;
        },

        isConnectionStepComplete() {
            return (
                this.isHeardFromFieldPopulated && this.isSubscribeFieldPopulated
            );
        },
    },

    watch: {
        isValid: function (newValue, oldValue) {
            this.validateAndSave();
        },
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["saveSubmission"]),

        openPrivacyPolicyModal() {
            jQuery("#dm-privacy-policy-modal").modal();
        },

        hideModalAndSaveSubmissions() {
            this.hideModals();
            this.submission.agree_privacy_policy = true;
            this.saveSubmission();
        },

        validateAndSave() {
            this.validate();
            this.saveSubmission(this.isConnectionStepComplete);
        },
    },
};
</script>
